<template>
  <BaseAction>
    <div class="d-flex justify-center approve-offer-action">
      <SecondaryButton @click.native="openDialog" color="primary">
        <inline-svg :src="require('@/assets/svg/check-green.svg')" />
        Accept Offer
      </SecondaryButton>
      <AcceptOfferDialog v-if="isOpen" @close="closeDialog" />
    </div>
  </BaseAction>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import AcceptOfferDialog from "@/views/offers/dialogs/AcceptOfferDialog";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "AcceptOfferAction",
  components: {
    SecondaryButton,
    AcceptOfferDialog,
    BaseAction,
    InlineSvg
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
